import { Components, Theme } from '@mui/material'
import PaletteTheme from '../palette'
import { THEME_CONSTANTS } from '../tokens/constants'

const tablePagination: Components<Theme>['MuiTablePagination'] = {
  defaultProps: {
    labelDisplayedRows: ({ from, to, count }) =>
      `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
  }
}

const formLabel: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    asterisk: {
      display: 'none'
    }
  }
}

const skeleton: Components<Theme>['MuiSkeleton'] = {
  styleOverrides: {
    root: {
      backgroundColor: PaletteTheme.grey?.[50]
    }
  }
}

const chip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: ({ ownerState }) => ({
      ...(!!ownerState.color &&
        ownerState.color != 'default' && {
          color: `var(--${ownerState.color}-700)`,
          backgroundColor: `var(--${ownerState.color}-50)`
        })
    }),
    deleteIcon: {
      color: 'var(--grey-300)',
      '&:hover': {
        color: 'var(--grey-200)'
      }
    }
  }
}

const menu: Components<Theme>['MuiMenu'] = {
  defaultProps: {
    slotProps: { paper: { style: { borderRadius: (THEME_CONSTANTS.SPACING * 3) / 2 } } }
  }
}

const tooltip: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    tooltip: {
      fontSize: '13px'
    }
  }
}

const slider: Components<Theme>['MuiSlider'] = {
  styleOverrides: {
    mark: {
      backgroundColor: 'var(--primary-500)',
      '&.MuiSlider-markActive': {
        backgroundColor: 'currentColor'
      },
      '&[style*="left:100%"], &[style*="left: 100%"]': {
        transform: 'translateX(-10px) translateY(-50%)'
      }
    },
    thumb: {
      '&[style*="left:0%"], &[style*="left: 0%"]': {
        transform: 'translateX(-5px) translateY(-50%)'
      },
      '&[style*="left:100%"], &[style*="left: 100%"]': {
        transform: 'translateX(-10px) translateY(-50%)'
      }
    }
  }
}

const dialog: Components<Theme>['MuiDialog'] = {
  defaultProps: {
    disableScrollLock: true,
    fullWidth: true,
    maxWidth: 'xs'
  },
  styleOverrides: {
    paper: ({ ownerState, theme }) => ({
      borderRadius: THEME_CONSTANTS.SPACING * 2,
      padding: THEME_CONSTANTS.SPACING * 3,
      gap: THEME_CONSTANTS.SPACING * 3,
      overflowX: 'hidden',

      '&.MuiDialog-paperFullScreen': {
        borderRadius: 0
      },

      ...(!ownerState.disableMobileFullScreen && {
        [theme.breakpoints.down('sm')]: {
          margin: 0,
          width: '100vw',
          maxWidth: '100vw !important',
          height: '100dvh',
          maxHeight: '100dvh',
          borderRadius: 0
        }
      }),

      '& .MuiDialogTitle-root': {
        padding: 0
      },

      '& .MuiDialogContent-root': {
        padding: 0
      },

      '& .MuiDialogActions-root': {
        padding: 0
      }
    })
  }
}

export { tablePagination, formLabel, skeleton, chip, menu, tooltip, slider, dialog }
